import type React from "react";

/**
 * EmptyState — bloco padrão pra "nada aqui ainda" / "vazio".
 *
 * Antes: cada lista (Quadro coluna vazia, Briefing, Integracoes,
 * Consumo, NovaTarefa) tinha seu próprio markup pra empty state.
 */

export function EmptyState({
  icon: IconCmp,
  title,
  description,
  action,
  dashed = true,
  style,
}: {
  icon?: React.ComponentType<{ size?: number; strokeWidth?: number; color?: string }>;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  dashed?: boolean;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`wf-card${dashed ? " wf-card--dashed" : ""}`}
      style={{
        padding: 28,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 10,
        ...style,
      }}
    >
      {IconCmp && (
        <span
          style={{
            width: 40,
            height: 40,
            borderRadius: 10,
            background: "rgba(255,112,0,0.10)",
            color: "var(--nd-orange)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 4,
          }}
        >
          <IconCmp size={20} strokeWidth={1.75} />
        </span>
      )}
      <div
        className="wf-display"
        style={{
          fontSize: 16,
          fontWeight: 700,
          letterSpacing: "-0.01em",
          color: "var(--wf-ink)",
        }}
      >
        {title}
      </div>
      {description && (
        <div
          style={{
            fontSize: 13,
            color: "var(--wf-ink-2)",
            lineHeight: 1.55,
            maxWidth: 460,
          }}
        >
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 6 }}>{action}</div>}
    </div>
  );
}
